// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum ChargeOrderInstructionType {
  ChargeWasNotPurchasedBefore = "CHARGE_WAS_NOT_PURCHASED_BEFORE",
  UnusedCharactersInLicensePlate = "UNUSED_CHARACTERS_IN_LICENSE_PLATE",
  IdentifiedPossibleExemption = "IDENTIFIED_POSSIBLE_EXEMPTION",
  VehicleCategoryWithoutChargeObligation = "VEHICLE_CATEGORY_WITHOUT_CHARGE_OBLIGATION",
  VehicleRegisterVerificationDisabled = "VEHICLE_REGISTER_VERIFICATION_DISABLED",
  VehicleUnverifiedWithVehicleRegister = "VEHICLE_UNVERIFIED_WITH_VEHICLE_REGISTER",
  MultipleVehiclesFoundInVehicleRegister = "MULTIPLE_VEHICLES_FOUND_IN_VEHICLE_REGISTER",
  IdentifiedFuelTypeLimitation = "IDENTIFIED_FUEL_TYPE_LIMITATION",
}
export default ChargeOrderInstructionType;
